import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';

const Icon = ({ name, color }) => (
    <FontIcon color={color} className="material-icons">
        {name}
    </FontIcon>
);

Icon.defaultProps = {
    color: undefined,
};

Icon.propTypes = {
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
};

export default Icon;
